import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import {
    getDropParentNodeId,
    getDropNodePosition,
    getDragNodePosition,
    getDropNodeId,
    getBootstrap,
    getFormId,
    getAdditionalGuestGroup,
} from '../../selectors';
import { openEditFormNode } from '../../actions';
import { removeFormNode } from '../../actions/nodeActions';
import { createFormNodeInAdditionalGuestInformationGroup } from '../../actions/additionalGuestActions';

import { beginDragFormNode, endDragFormNode, hoverDropFormNode } from '../../actions/dragActions';

import FormEditorNodeChildrenWrapper from './FormEditorNodeChildrenWrapper';
import FormEditorNode from './FormEditorNode';

import { INPUT_TYPE_DISPLAY_NAMES } from '../../constants/bootstrapKeys';

/**
 * Renders the additional guest questions right below the "Additional Guests" Group.
 * It's used to hide the real structure behind the scenes and provide a UI to edit them and
 * bring them back if deleted.
 */
class AdditionalGuestsLayoutSubSection extends Component {
    static propTypes = {
        additionalGuestGroupNode: PropTypes.object.isRequired,
        dragNodeId: PropTypes.string,
        dropParent: PropTypes.string,
        dropNodeId: PropTypes.string,
        dropNodePosition: PropTypes.number,
        dragNodePosition: PropTypes.number,
    };
    static defaultProps = {
        dragNodeId: '',
        dropParent: '',
        dropNodeId: '',
        dropNodePosition: 0,
        dragNodePosition: 0,
    };

    render() {
        return (
            <div className="form-node-children-shadow">
                <FormEditorNodeChildrenWrapper
                    parentId={this.props.additionalGuestGroupNode.parent}
                    formNodeIds={this.props.additionalGuestGroupNode.children}
                    dropParent={this.props.dropParent}
                    dragNodeId={this.props.dragNodeId}
                    dropNodeId={this.props.dropNodeId}
                    dropNodePosition={this.props.dropNodePosition}
                    dragNodePosition={this.props.dragNodePosition}
                    depth={0}
                >
                    {(formNodeId, index) => (
                        <FormEditorNode
                            key={formNodeId}
                            depth={2}
                            formNodeId={formNodeId}
                            siblingNodePosition={index}
                        />
                    )}
                </FormEditorNodeChildrenWrapper>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const formId = getFormId(state);
    const additionalGuestGroupNode = getAdditionalGuestGroup(state, formId);

    const dropParent = getDropParentNodeId(state);
    const isDropParent = getDropParentNodeId(state) === additionalGuestGroupNode.id;

    const dropNodePosition = getDropNodePosition(state);
    const dragNodePosition = getDragNodePosition(state);
    const dropNodeId = getDropNodeId(state);

    return {
        additionalGuestGroupNode,
        isDropParent,
        dropParent,
        dropNodeId,
        dropNodePosition,
        dragNodePosition,
        bootstrapInputTypeDisplayNames: getBootstrap(state)[INPUT_TYPE_DISPLAY_NAMES],
    };
};

const mapDispatchToProps = {
    openEditFormNode,
    createFormNodeInAdditionalGuestInformationGroup,
    removeFormNode,
    beginDragFormNode,
    endDragFormNode,
    hoverDropFormNode,
};

export default connect(mapStateToProps, mapDispatchToProps)(AdditionalGuestsLayoutSubSection);
